/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';


export default ({ label, children }) =>
(
  <Flex direction = 'column' gap = '1'>
    <Text.Note>{label}</Text.Note>
    {children}
  </Flex>
);
